import { Component, inject, input, output } from '@angular/core';
import { Router } from '@angular/router';
import { ActionMenuItem } from './action-menu-item.model';
import { SHARED_MENU_IMPORTS } from '@shared/modules/shared-menu-module';
// import { useActionMenu } from './action-menu-composable';
@Component({
  selector: 'action-menu',
  imports: [...SHARED_MENU_IMPORTS],
  templateUrl: './action-menu.html',
  styles: ``,
})
export class ActionMenu {
  readonly items = input<ActionMenuItem[]>([]);
  readonly icon = input<string>('menu');
  private readonly router = inject(Router);
  readonly clickAction = output<string>();
  readonly actionData = input<any>(null);

  navigateTo(route: string) {
    this.router.navigate([route]);
  }

  setActionTitle(item: ActionMenuItem) {
    if (item.statefulTitle) {
      return item.statefulTitle({state: this.actionData()?.isActive, truthyStatefulTitle: 'Deactivate', falsyStatefulTitle: 'Activate'});
    }
    return item.title;
  }

  doActionType(action: string, route?: string) {
    switch (action) {
      case 'pageChange':
        this.navigateTo(route+'/'+this.actionData().id);
        break;
      default:
        this.clickAction.emit(action);
        break;
    }
    
  }
}
